import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import PlanDetailsDialog from './plan-details.vue';
import { logger } from '@/utils/log';

export default {
  data() {
    return {
      planDetailsDialog: null,
    };
  },
  created() {
    this.planDetailsDialog = new ServiceConfirm(PlanDetailsDialog);
  },
  methods: {
    async showPlanDetailDialog(dialogProps = {}) {
      try {
        this.$tracking.buyInteraction('plan details selected', dialogProps.trackingPlanName || '');
        await this.planDetailsDialog.confirm(dialogProps);
      } catch (error) {
        logger.warn('Failed to show plan detail dialog or hidden the dialog', error);
        return null;
      }
    },
  },
};
